'use strict'

import React, { Component, PropTypes } from 'react';
import { DropTarget } from 'react-dnd';

class DragAndDropTarget extends React.Component {
  render() {
    const { connectDropTarget, isOver } = this.props;
    return connectDropTarget(
      <div style={{backgroundColor:isOver ? "grey" : undefined}}>
        {this.props.children}
      </div>
    );
  }
}

const prioritizedTarget = {
  drop(props) {
    return {position: props.position};
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

export default DropTarget('project', prioritizedTarget, collect)(DragAndDropTarget);



// WEBPACK FOOTER //
// ./views/components/DragAndDropTarget.jsx